import { Fragment } from 'react';
import meal from '../../assets/meal.jpg';
import classes from '../Layout/Header.module.css';
import HeaderCartButton from './HeaderCartButton';

const Header = props => {
    return (
        <Fragment>
            <header className={classes.header}>
                <h2> Poorna Kitchens </h2>
                <HeaderCartButton onClick={props.onShowCart} />
            </header>
            <div className={classes['main-image']}>
                <img src={meal} alt = "food pic" />
            </div>
        </Fragment>
    );
}
export default Header;